import { Box, HStack, Spinner, Text, VStack } from '@chakra-ui/react'

/**
 * StatsCard Component
 * Displays a statistic with icon, label, and value
 */
export function StatsCard({
  icon,
  label,
  value,
  color = '#0052CC',
  isLoading = false,
  onClick,
}) {
  return (
    <Box
      bg="white"
      borderRadius="6px"
      border="1px solid #DFE1E6"
      boxShadow="0 1px 1px rgba(9, 30, 66, 0.08)"
      p={5}
      cursor={onClick ? 'pointer' : 'default'}
      transition="all 0.2s"
      _hover={onClick ? {
        borderColor: color,
        boxShadow: '0 2px 4px rgba(9, 30, 66, 0.15)',
        transform: 'translateY(-2px)',
      } : {}}
      onClick={onClick}
    >
      <HStack spacing={4} align="start">
        {/* Icon */}
        <Box
          bg={`${color}15`}
          borderRadius="6px"
          p={3}
          fontSize="24px"
        >
          {icon}
        </Box>

        {/* Content */}
        <VStack align="start" spacing={1} flex={1}>
          <Text
            fontSize="13px"
            color="#5E6C84"
            fontWeight="600"
            textTransform="uppercase"
            letterSpacing="0.5px"
          >
            {label}
          </Text>
          {isLoading ? (
            <Spinner size="sm" color={color} />
          ) : (
            <Text
              fontSize="32px"
              color="#172B4D"
              fontWeight="700"
              lineHeight="1"
            >
              {value ?? '—'}
            </Text>
          )}
        </VStack>
      </HStack>
    </Box>
  )
}

export default StatsCard
